import React from 'react'
import { images } from '../../../utils/customFn';
import './claimheader.scss'
import { Link } from 'react-router-dom';
const ClaimstatusHeader = () => {
  return (
    <div className='claimstatus-header'>
        <div className='logo'>
           <Link to="/claims"> <img src={images['logo.avif']} alt='logo' className='logo'/></Link>
        </div>
        <div className='change-lang'>
            <button type='text'>Cambiar a Español {'>'}</button>
        </div>
    </div>
  )
}

export default ClaimstatusHeader;
